import { gql } from "@apollo/client";

export const COUPON = gql`
  query queryCoupon($id: Float!) {
    coupon(id: $id) {
      id
      name
      type
      value
      amount
      validity
      franchise_id
      acting_region_id
      is_actived
      is_deleted
    }
  }
`;

export const COUPONS = gql`
  query queryCoupons($filter: UpdateCouponInput, $franchise_id: Float) {
    coupons(filter: $filter) {
      id
      name
      type
      value
      amount
      validity
      franchise_id
      acting_region_id
      is_actived
      is_deleted
      franchise {
        id
        name
      }
      actingRegion {
        id
        name
      }
    }
    franchises {
      id
      name
    }
    regions(franchise_id: $franchise_id) {
      id
      name
    }
  }
`;

export default COUPONS;
